import "./App.css";
import FinancingRequestForm from "./components/FinancingRequestForm/FinancingRequestForm";

export default function App() {
  return (
    <div className="app">
      <FinancingRequestForm />
    </div>
  );
}
